// @ts-ignore
var $node = $node || {}
